import { createContext, useContext, useState, useEffect, useCallback } from 'react';

const WishlistContext = createContext(null);
const STORAGE_KEY = 'noora_wishlist';

export const WishlistProvider = ({ children }) => {
    const [wishlistIds, setWishlistIds] = useState(() => {
        try {
            const saved = localStorage.getItem(STORAGE_KEY);
            return saved ? new Set(JSON.parse(saved)) : new Set();
        } catch { return new Set(); }
    });

    useEffect(() => {
        localStorage.setItem(STORAGE_KEY, JSON.stringify([...wishlistIds]));
    }, [wishlistIds]);

    const toggleWishlist = useCallback((productId) => {
        setWishlistIds(prev => {
            const next = new Set(prev);
            if (next.has(productId)) {
                next.delete(productId);
            } else {
                next.add(productId);
            }
            return next;
        });
    }, []);

    const isInWishlist = useCallback((productId) => wishlistIds.has(productId), [wishlistIds]);

    const clearWishlist = useCallback(() => {
        setWishlistIds(new Set());
    }, []);

    return (
        <WishlistContext.Provider value={{
            wishlistIds, toggleWishlist, isInWishlist, clearWishlist,
            wishlistCount: wishlistIds.size
        }}>
            {children}
        </WishlistContext.Provider>
    );
};

const defaultValue = {
    wishlistIds: new Set(), toggleWishlist: () => {}, isInWishlist: () => false,
    clearWishlist: () => {}, wishlistCount: 0
};
export const useWishlist = () => useContext(WishlistContext) || defaultValue;
